<template>
  <div class="ios-glass-page">
    <!-- 1. 动态背景光斑 -->
    <div class="background-blobs">
      <div class="blob blob-1"></div>
      <div class="blob blob-2"></div>
      <div class="blob blob-3"></div>
    </div>

    <!-- 2. 头部学校信息 -->
    <!-- <div class="glass-container header-card">
      <div class="header-content">
        <div class="avatar-base" style="background: #007AFF;">
          <van-icon name="shop-o" size="24" color="#fff" />
        </div>
        <div class="info-text">
          <h2 class="school-name">{{ teacherTitleInfo.schoolName || '控制中心' }}</h2>
          <span class="user-role">设备管理 / 户外跑 & 跳跳乐园</span>
        </div>
      </div>
    </div>

    <div class="glass-container">
      <h3 class="panel-title">户外跑</h3>
      <div class="ios-list-group">
        
        <div class="ios-list-item" @click="onIssueAnOrder">
          <div class="item-left">
            <div class="icon-base" style="background: #FF9500;">
              <van-icon name="aim" size="20" color="#fff" />
            </div>
            <span class="item-text">户外跑遥控</span>
          </div>
          <van-icon name="arrow" class="item-arrow" />
        </div>

      </div>
    </div> -->

    <!-- 4. 卡片二：跳跳乐园 -->
    <div class="glass-container">
      <h3 class="panel-title">跳跳乐园</h3>
      <div class="ios-list-group">
        
        <!-- 按钮项：项目切换 -->
        <div class="ios-list-item" @click="todeviceControl">
          <div class="item-left">
            <!-- 蓝色底座 -->
            <div class="icon-base" style="background: #007AFF;">
              <van-icon name="apps-o" size="20" color="#fff" />
            </div>
            <span class="item-text">项目切换</span>
          </div>
          <van-icon name="arrow" class="item-arrow" />
        </div>



        
        <!-- 按钮项：视讯视频切换 -->
        <div class="ios-list-item" @click="todeviceControlVideo">
          <div class="item-left">
            <!-- 紫色底座 -->
            <div class="icon-base" style="background: #AF52DE;">
              <van-icon name="video-o" size="20" color="#fff" />
            </div>
            <span class="item-text">视讯视频切换</span>
          </div>
          <van-icon name="arrow" class="item-arrow" />
        </div>

        <!-- 按钮项：手机遥控器（选人上场） -->
        <div class="ios-list-item" @click="todevicePhoneControl">
          <div class="item-left">
            <!-- 绿色底座 -->
            <div class="icon-base" style="background: #34C759;">
              <van-icon name="friends-o" size="20" color="#fff" />
            </div>
            <span class="item-text">手机遥控器（选人上场）</span>
          </div>
          <van-icon name="arrow" class="item-arrow" />
        </div>

      </div>
    </div>

       <div class="glass-container">
      <h3 class="panel-title">一体机设备</h3>
      <div class="ios-list-group">
    <div class="ios-list-item" @click="todedeviceTypeControl">
          <div class="item-left">
            <!-- 蓝色底座 -->
            <div class="icon-base" style="background: #007AFF;">
              <van-icon name="apps-o" size="20" color="#fff" />
            </div>
            <span class="item-text">设备程序切换</span>
          </div>
          <van-icon name="arrow" class="item-arrow" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// 逻辑部分保持不变
import { Dialog } from 'vant';
import { 
  getFlowableSchoolCorxInfoList, 
  selectSchoolDeviceList 
} from "@/api/teacher/outdoorRunning.js";

export default {
  name: "PowerSwitchGlassSolid",
  data() {
    return {
      teacherTitleInfo: {},
    };
  },
  mounted() {
    const info = sessionStorage.getItem('teacherTitleInfo');
    if (info) {
      this.teacherTitleInfo = JSON.parse(info);
    }
  },
  methods: {
    todeviceControl() {
      this.$router.push({ path: '/deviceControl' });
    },
    todedeviceTypeControl() {
      this.$router.push({ path: '/deviceTypeControl' });
    },
    
    todeviceControlVideo() {
      this.$router.push({ path: '/deviceControlVideo' });
    },
    todevicePhoneControl() {
      this.$router.push({ path: '/devicePhoneControl' });
    },
    onIssueAnOrder() {
      this.$router.push({ path: '/outdoorRunning/WiFiCheck' });
    },
    tooutdoorRunningConfig() {
      this.$router.push({ path: '/outdoorRunning/outdoorRunningConfig' });
    },
    getList() {}
  },
};
</script>

<style lang="less" scoped>
/* ---------------- 页面基础 ---------------- */
.ios-glass-page {
  min-height: 100vh;
  width: 100%;
  /* 稍微加深一点背景，突出彩色图标的质感 */
  background: radial-gradient(circle at top left, #f0f2f5, #cfd9df);
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", Helvetica, Arial, sans-serif;
  padding: 16px;
  box-sizing: border-box;
  overflow-y: auto;
  position: relative;
}

/* ---------------- 动态背景光斑 ---------------- */
.background-blobs {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;

  .blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    opacity: 0.5;
    animation: float 10s infinite ease-in-out;
  }
  .blob-1 { width: 260px; height: 260px; background: #d0e1ff; top: -60px; left: -40px; }
  .blob-2 { width: 220px; height: 220px; background: #ffe5d0; bottom: 20%; right: -30px; animation-delay: -3s; }
  .blob-3 { width: 180px; height: 180px; background: #e0f2f1; top: 40%; left: 40%; animation-delay: -6s; opacity: 0.4; }
}

// @keyframes float {
//   0%, 100% { transform: translate(0, 0); }
//   50% { transform: translate(20px, 30px); }
// }

/* ---------------- 通用毛玻璃卡片 ---------------- */
.glass-container {
  position: relative;
  z-index: 1;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(12px) ;
  -webkit-backdrop-filter: blur(12px) ;
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 24px -1px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  padding: 20px 16px;
  margin-bottom: 20px;
}

/* ---------------- 头部样式 ---------------- */
.header-card {
  margin-top: 10px;
  padding: 16px;
  
  .header-content {
    display: flex;
    align-items: center;
  }

  /* 头部图标底座 */
  .avatar-base {
    width: 44px; /* 稍微调小一点，更精致 */
    height: 44px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    /* 给彩色底座加一点阴影 */
    box-shadow: 0 4px 10px rgba(0, 122, 255, 0.3);
    margin-right: 12px;
  }

  .info-text {
    display: flex;
    flex-direction: column;

    .school-name {
      margin: 0;
      font-size: 17px;
      font-weight: 600;
      color: #1c1c1e;
    }

    .user-role {
      font-size: 12px;
      color: #8e8e93;
      margin-top: 3px;
    }
  }
}

/* ---------------- 列表分组样式 ---------------- */
.panel-title {
  font-size: 13px;
  font-weight: 600;
  color: #6e6e73;
  margin: 0 0 10px 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.ios-list-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* iOS 列表项按钮 */
.ios-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffffc4;
  padding: 12px 16px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.8);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
  
  &:active {
    transform: scale(0.98);
    background-color: #f2f2f7;
  }

  .item-left {
    display: flex;
    align-items: center;
  }

  /* 列表项图标底座 (纯色底) */
  .icon-base {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    /* 这里的背景色由 inline-style 决定 */
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 14px;
    /* 增加微弱的彩色投影，让颜色更润 */
    box-shadow: 0 2px 6px rgba(0,0,0,0.15); 
  }

  .item-text {
    font-size: 16px;
    color: #1c1c1e;
    font-weight: 500;
  }

  .item-arrow {
    color: #c7c7cc;
    font-size: 18px;
  }
}
</style>